
import { CsFlex } from '@consteel/csuetify'
import Vue from 'vue'
import HelpCard from './Components/HelpCard.vue'
import HelpTable from './Components/HelpTable.vue'

export default Vue.extend({
  name: 'HelpPricingAndLimitations',
  components: {
    CsFlex,
    HelpCard,
    HelpTable,
  },
  data() {
    return {
      whoCanUseSteelspace: this.$t(
        'During this introductory period, accessing public models is free for users with a Consteel account registered at <a palce="consteelsoftware" href="https://consteelsoftware.com" target="_blank">consteelsoftware.com</a>.'
      ),
      additionalServices: this.$t(
        'All additional services of Steelspace are available for users requesting a Consteel Software <a palce="consteelsoftware" href="https://consteelsoftware.com/products/offers-licensing/" target="_blank">subscription plan</a>. <br/>Service limitations are based on the membership level included in the subscription plan.'
      ),
    }
  },
})
